import React from "react";
import Line from "../../../assets/line2.svg";
import MainImg from "../../../assets/illustrations2/PNG/bulk_page_v-a_bul_upload_section.png";

export default function TestimonialOne() {
  return (
    <div>
      <h2 className="text-3xl bg-gray-50 pt-8 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:pt-16 md:pb-3">
        Let Us Do the{" "}
        <span className="relative inline-block">
          Hard Work{" "}
          <img
            src={Line}
            alt="Underline decoration"
            className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
          />
        </span>
      </h2>
      <h2 className="text-3xl pt-2 lg:pt-0 bg-gray-50 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center">
        ExactMails handles the searching for you.{" "}
      </h2>
      <div className="bg-gray-50 p-8 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
          <div
            className={`flex justify-center items-center mt-8 md:mt-0 md:w-[45%] md:order-2`}
          >
            <img
              src={MainImg}
              alt="Expanded section preview"
              className="md:w-full w-96"
            />
          </div>

          <div className={`text-left md:w-[55%] md:order-1 lg:mt-10 md:p-6`}>
            <p className="text-[22px] my-6 lg:mb-12">
              Effortlessly grow your verified contact lists with ExactMails.io’s
              Bulk Email Finder. Whether you’re generating leads, building
              outreach campaigns, or enhancing your CRM database
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
